// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w_xt","newExpiryDate":"styles_newExpiryDate__1tSwE","footer":"styles_footer__1sLln"};